import { MessageCircle } from "lucide-react";
import { openSam, samPromptsFor } from "@/lib/sam-open";
import { trackEvent } from "@/lib/analytics";

/** In-article prompt that opens SAM with a topic-specific question. */
export function AskSamCard({ productKey, topic }: { productKey: string; topic: string }) {
  const prompts = samPromptsFor(productKey);
  const ask = (q?: string) => {
    trackEvent("ask_sam_card_click", { page: typeof window !== "undefined" ? window.location.pathname : "" });
    openSam(q);
  };
  return (
    <aside className="my-10 rounded-2xl border border-brand/25 bg-brand/5 p-5 sm:p-6">
      <div className="flex items-center gap-2 text-sm font-bold text-brand">
        <MessageCircle className="h-5 w-5" /> Questions about {topic}?
      </div>
      <p className="mt-2 text-sm text-muted-foreground">
        Ask SAM, our investor assistant, for a quick plain-English answer — any time. A licensed loan
        officer can follow up on your actual deal. Answers are educational, not an offer of credit.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        {prompts.map((q) => (
          <button
            key={q}
            type="button"
            onClick={() => ask(q)}
            className="rounded-full border border-brand/30 bg-background px-3 py-1.5 text-left text-sm font-medium text-foreground transition hover:border-brand hover:bg-brand/10"
          >
            {q}
          </button>
        ))}
        <button
          type="button"
          onClick={() => ask()}
          className="rounded-full bg-brand px-4 py-1.5 text-sm font-semibold text-primary-foreground transition hover:bg-brand-dark"
        >
          Ask SAM my own question
        </button>
      </div>
    </aside>
  );
}
